import { render, staticRenderFns } from "./followsRecord.vue?vue&type=template&id=176b0f0c&scoped=true&"
import script from "./followsRecord.vue?vue&type=script&lang=js&"
export * from "./followsRecord.vue?vue&type=script&lang=js&"
import style0 from "./followsRecord.vue?vue&type=style&index=0&id=176b0f0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b0f0c",
  null
  
)

component.options.__file = "followsRecord.vue"
export default component.exports